import { Box, Typography } from "@mui/material";
import ActionsCell from "./ActionsCell";

export const getColumns = (setOpenDeleteDepot, setSelectedDepot, setRefreshList) => [
  {
    field: "depo",
    headerName: "Depot Name",
    width: 250,
    renderCell: (params) => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#48505E",
          }}
        >
          {params.row.depo}
        </Typography>
      </Box>
    ),
  },
  {
    field: "depo_code",
    headerName: "Depot Code",
    width: 180,
    renderCell: (params) => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#48505E",
          }}
        >
          {params.row.depo_code}
        </Typography>
      </Box>
    ),
  },
  {
    field: "full_address",
    headerName: "Full Address",
    width: 400,
    renderCell: (params) => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#48505E",
            whiteSpace: "normal",
            lineHeight: 1.3,
          }}
        >
          {params.row.full_address || "-"}
        </Typography>
      </Box>
    ),
  },
  {
    field: "created_at",
    headerName: "Created At",
    width: 200,
    renderCell: (params) => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#48505E",
          }}
        >
          {params.row.created_at ? new Date(params.row.created_at).toLocaleString() : "-"}
        </Typography>
      </Box>
    ),
  },
  {
    field: "updated_at",
    headerName: "Updated At",
    width: 200,
    renderCell: (params) => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#48505E",
          }}
        >
          {params.row.updated_at ? new Date(params.row.updated_at).toLocaleString() : "-"}
        </Typography>
      </Box>
    ),
  },
  {
    field: "action",
    headerName: "Actions",
    width: 250,
    sortable: false,
    renderCell: (params) => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <ActionsCell
          params={params}
          setOpenDeleteDepot={setOpenDeleteDepot}
          setSelectedDepot={setSelectedDepot}
          setRefreshList={setRefreshList}
        />
      </Box>
    ),
  },
];